import { render, staticRenderFns } from "./UserRegNotice.vue?vue&type=template&id=4331992a&scoped=true&"
var script = {}
import style0 from "./UserRegNotice.vue?vue&type=style&index=0&id=4331992a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331992a",
  null
  
)

export default component.exports